<form
  class="flex flex-col justify-between md:px-10 xl:w-[1300px]"
  [formGroup]="mealFormService.mealForm"
>
  <section class="m-auto flex max-w-[500px] flex-1 flex-col md:gap-10">
    <div class="flex flex-col gap-4">
      <h2 class="text-center text-primary-900">
        {{ "prestation.meal.title" | transloco }}
      </h2>
      <p class="text-center text-paragraph-s-reg">
        {{ "prestation.meal.description" | transloco }}
      </p>
    </div>

    <div>
      <app-select-meal-type />
      <app-error [control]="typeControl" />
    </div>

    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex flex-col gap-2">
        <h4 class="text-primary-900">
          {{ "calculator.label.MealPercentage" | transloco }}
        </h4>
        <p class="text-paragraph-xs-reg">
          {{ "prestation.mealPercentage.description" | transloco }}
        </p>
      </div>
      <app-percentage
        name="mealPercentage"
        [fluid]="true"
        placeholder="%"
        [control]="mealPercentageControl"
      />
      <app-error [control]="mealPercentageControl" />
    </section>

    <section class="flex flex-1 flex-col gap-4 rounded-lg bg-primary-50 p-4">
      <div class="flex flex-col gap-2">
        <h4 class="text-primary-900">
          {{ "calculator.label.localAndSeasonal" | transloco }}
        </h4>
        <p class="text-paragraph-xs-reg">
          {{ "prestation.localAndSeasonal.description" | transloco }}
        </p>
      </div>
      <app-percentage
        name="localSeasonalPercent"
        [fluid]="true"
        placeholder="%"
        [control]="localAndSeasonalControl"
      />
      <app-error [control]="localAndSeasonalControl" />
    </section>
  </section>
</form>
<div class="flex flex-row items-end justify-end gap-4">
  <p-button
    [label]="'close' | transloco"
    (click)="close()"
    severity="secondary"
    [text]="true"
  />

  <p-button
    [label]="'save' | transloco"
    (click)="submit()"
    [loading]="loading"
    [disabled]="mealFormService.mealForm.invalid"
  />
</div>
